export default __webpack_public_path__ + "static/media/qr_stores.d696c257.svg";